import { useState } from 'react';

import { MultiSelectWithCheckboxes } from 'uiToolkitV1/MultiSelectWithCheckboxes/MultiSelectWithCheckboxes';

const LOCATION_OPTIONS = [
  {
    value: 'NewYork',
    label: 'New York',
  },
  {
    value: 'LosAngeles',
    label: 'Los Angeles',
  },
  {
    value: 'Chicago',
    label: 'Chicago',
  },
  {
    value: 'Houston',
    label: 'Houston',
  },
  {
    value: 'Phoenix',
    label: 'Phoenix',
  },
];

export const CompensationLocationDropdown = () => {
  const [selectedLocations, setSelectedLocations] = useState<typeof LOCATION_OPTIONS>([
    { value: 'NewYork', label: 'New York' },
  ]);

  return (
    <MultiSelectWithCheckboxes
      options={LOCATION_OPTIONS}
      selectedOptions={selectedLocations}
      onChange={setSelectedLocations}
      label="Location"
      placeholder="Select Location"
    />
  );
};
